import { Component, computed, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { DatePipe } from '../../pipes/date.pipe';
import { CurrentUserService } from '../../services/currentUser.service';
import { ViewEulaComponent } from '../view-eula/view-eula.component';
import { wideModalConfig } from '../../consts/modal-config.const';

@Component({
  selector: 'support-menu-content',
  imports: [DatePipe, MatDivider, MatIcon],
  host: { class: 'text-16 leading-16' },
  template: `
    <div class="text-22 leading-22 font-semibold">Stelvio is here to help</div>

    <mat-divider class="my-20!" />

    <div class="grid gap-y-10">
      <div>Support</div>

      <div>(02) 9455 1055</div>

      <div class="text-12 leading-12 text-neut-40">8:30am to 5pm, Monday to Friday</div>

      <div>ozsupport@stelvio.com.au</div>
    </div>

    <mat-divider class="my-20!" />

    <div class="grid gap-y-10">
      <div>Guides</div>
      <div
        class="flex items-center gap-x-10 hover:cursor-pointer font-medium"
        (click)="openGuidesInNewTab('QuickStartGuide.pdf')">
        <div>EIO Quick Start Guide</div>
        <mat-icon class="size-18! text-18! text-red!"> open_in_new </mat-icon>
      </div>
    </div>

    @if (isRepAdmin() || isRepairerUser()) {
      <mat-divider class="my-20!" />

      <div class="grid gap-y-10">
        <div class="flex items-center gap-x-10 hover:cursor-pointer font-medium" (click)="openEULA()">
          <div>End-user licence agreement</div>
          <mat-icon class="size-18! text-18! text-red!"> open_in_new </mat-icon>
        </div>

        <div>
          Accepted on {{ currentUser()?.eulaApprovedDateTime | dateepoch: currentTimeZone() }} by
          {{ currentUser()?.eulaApprovedBy }}
        </div>
      </div>
    }
  `
})
export class SupportMenuContentComponent {
  #currentUserService = inject(CurrentUserService);
  #dialog = inject(MatDialog);

  currentUser = this.#currentUserService.currentUser;
  currentTimeZone = this.#currentUserService.currentTimeZone;
  currentUserPrivileges = this.#currentUserService.currentUserPrivileges;
  isRepairerUser = this.#currentUserService.isRepairerUser;

  isRepAdmin = computed(
    () =>
      this.currentUserPrivileges().includes('REPADMIN') &&
      !this.currentUserPrivileges().includes('SYSADMIN') &&
      !this.currentUserPrivileges().includes('MLADMIN')
  );

  openEULA(): void {
    this.#dialog.open(ViewEulaComponent, wideModalConfig);
  }

  openGuidesInNewTab(fileName: string): void {
    window.open(`https://stelvio-media-public.s3.amazonaws.com/repairer/${fileName}`, '_blank');
  }
}
